import {
	Bar,
	BarChart,
	CartesianGrid,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from 'recharts';

const ActividadesMensualesChart = ({ data }) => (
	<ResponsiveContainer width='100%' height={300}>
		<BarChart data={data}>
			<CartesianGrid strokeDasharray='3 3' />
			<XAxis dataKey='mes' />
			<YAxis />
			<Tooltip />
			<Bar dataKey='total' fill='#3182CE' />
		</BarChart>
	</ResponsiveContainer>
);

export default ActividadesMensualesChart;
